import { Grid, GridColumnResizeEvent } from '@progress/kendo-react-grid';
import { createRef, useEffect } from 'react';
import { SetState } from 'src/types/generic';

export const handleScrollDown = () => {
  const windowHeight = window.innerHeight;
  const totalPageHeight = document.documentElement.scrollHeight;
  const newScrollPosition = totalPageHeight - windowHeight;
  window.scrollTo(0, newScrollPosition);
};

export const handleColumnResize = (event: GridColumnResizeEvent) => {
  const { element } = event.target;
  const newElement = element?.getBoundingClientRect();
  const position = newElement?.top || 0;
  const scrollPosition = Math.floor((position + window.scrollY) / 2);
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth',
  });
};

const useScrollDown = (
  trigger: boolean,
  setTrigger: SetState<boolean>,
  dependencyList: React.DependencyList
) => {
  const tableRef = createRef<Grid>();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (tableRef.current?.element && trigger) {
      const grid = tableRef.current?.element;
      const content = grid?.getElementsByClassName('k-grid-content')[0] as HTMLElement;
      const scrollPosition = content.scrollHeight - content.clientHeight;
      timer = setTimeout(() => {
        content.scrollTop = scrollPosition; // set table scroll position
        handleScrollDown(); // set page scroll position
        setTrigger(false);
      }, 100);
    }
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, tableRef, ...dependencyList]);
  return tableRef;
};

export default useScrollDown;
